export default __webpack_public_path__ + "static/handshake_with_metaloop-acc9c98fc839ec8f6b480ebac29f9fc2.svg";